<!-- TODO: Multilang -->

<template>
  <div>
    <v-btn fab text small class="header-arrow-button" @click="calendarAction('prev')">
      <v-icon small>mdi-arrow-left-drop-circle-outline</v-icon>
    </v-btn>
    {{ calendar_props.title }}
  
      <!-- New menu -->
    <v-menu
      dense
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click.stop>
          <v-autocomplete
            :value="selected"
            :items="date_fields"
            :label="$vuetify.lang.translator('filters.dates.date_field')"
            :multiple="false"
            item-text="name"
            item-value="id"
            dense
            :full-width="true"
            small-chips
            return-object
            hide-details
            outlined
            :search-input.sync="search_text"
            @input="update_date_field"
          >
          </v-autocomplete>
        </v-list-item>
        <!-- GO TO TODAY -->
        <v-list-item @click="calendarAction('setToday')">          
          <v-list-item-title>{{ $vuetify.lang.translator('go_to_today') }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar-today</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-group  no-action @click.stop>
          <template v-slot:activator>
            <v-list-item-title>
              {{ $vuetify.lang.translator('calendar_type') }}: {{ typeToLabel[calendar_props.type] }} 
            </v-list-item-title>
          </template>
          <v-list-item-group 
            v-model="type_selected" 
            class="pl-10" 
            active-class="qmkey-explorer-view-active"
            mandatory
          >
            <v-list-item
              v-for="(label, type) in typeToLabel"
              :key="type"
              @click="calendarAction('setType', type)"
              > <!-- TODO: WIP! -->
              <v-list-item-title>{{ label }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon>{{ typeToIcon[type] }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group
          no-action
          @click.stop
        >
          <template v-slot:activator>
            <v-list-item-title>
              {{ $vuetify.lang.translator('current_day_interval') }} : {{weekdays[days_selected].label}}
            </v-list-item-title>
          </template>
          <v-list-item-group 
            mandatory
            v-model="days_selected"
            class="pl-10" 
            active-class="qmkey-explorer-view-active"
          >
            <v-list-item
              v-for="(days, i) in weekdays"
              :key="i"
              @click="calendarAction('setDays', days.value)"
              :class="days.value == weekday ? 'menu-options-selected' : ''"
            > <!-- TODO: WIP! -->
              <v-list-item-title>{{ days.label }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon>mdi-numeric-{{ i }}-circle-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group >
        </v-list-group>
      </v-list>
    </v-menu>
    <!-- // New menu -->
    <v-btn fab text small class="header-arrow-button" @click="calendarAction('next')">
      <v-icon small>mdi-arrow-right-drop-circle-outline</v-icon>
    </v-btn>
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import "@/sass/explorer/calendar.scss";
</style>
  
  
<script>
  import { mapGetters } from 'vuex';
  import QUnitAPI from '@/api/QUnit';
  import { QFilters } from '@/qunit/filters';
  export default {
    name: 'ExplorerCalendarHeader',
    components: {},
  
    props: {
      'filters': QFilters,
      'calendar_props': {default: () => ({})},
    },
  
    data: () => ({
      typeToIcon: {
        month: 'mdi-calendar-month',
        week: 'mdi-calendar-week',
        day: 'mdi-calendar-blank',
      },
      dayToLabel: {
        0: 'Domingo',
        1: 'Lunes',
        2: 'Martes',
        3: 'Miércoles',
        4: 'Jueves',
        5: 'Viernes',
        6: 'Sábado',
      },
      weekday: [],
      type_selected: 0,
      days_selected: 1,
      labels: {
        month: 'monthly',
        week: 'weekly',
        day: 'daily',
      },
      week_days: ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'],

      selected: null,
      date_fields: [],
      search_text: null,
    }),

    computed: {
      ...mapGetters([
        'sitePath',
        'centro_id',
      ]),

      business_process() {
        return this.filters.get_filter_value('business_process');
      },
      typeToLabel() {
        return Object.fromEntries(Object.entries(this.labels).map(([label,type]) => ([label,this.$vuetify.lang.translator(type)])));
      },
      week_days_lang(){
        return this.week_days.map(day => this.$vuetify.lang.translator('week_days.short.'+day));
      },
      weekdays() {
        let days = Object.fromEntries(this.week_days_lang.entries())
        return [
          { label: days[0] +' - '+ days[6], value: [0, 1, 2, 3, 4, 5, 6] },
          { label: days[1] +' - '+ days[0], value: [1, 2, 3, 4, 5, 6, 0] },
          { label: days[1] +' - '+ days[5], value: [1, 2, 3, 4, 5] },
          { label: days[1] +', '+  days[3] + ', '  + days[5], value: [1, 3, 5] },
        ]
      },
    },

    mounted() {
      this.setDatesFields();
      
      this.selected = {id: this.calendar_props.field || 'current_workflow_limit'};
    },
  
    methods: {
      calendarAction(action, ...args) {
        let props = {...this.calendar_props};
        props.calendar_action = {'action': action, 'args': args};

        this.update_props(props);
      },
      
      setSelected(obj){
        console.log('CalendarHeader.setSelected', obj)
      },

      update_props(props) {
        this.$emit('update_props',props);
      },

      async setDatesFields() {
        // Don't worry, the API call is cached on the frontend ;-)
        const data = await QUnitAPI.getFieldsByTypeToCollectForFiltering(
          this.centro_id,
          this.business_process
        );
        this.date_fields = data.fields;
      },

      update_date_field(field) {
        this.selected = field;
        const props = {...this.calendar_props,'field': field.id};
        this.update_props(props);
      }
    },
    watch: {
      calendar_props() {
        this.type_selected=Object.entries(this.typeToLabel).map(v => v[0]).indexOf(this.calendar_props.type)
      },
    },
  }
</script>
  